// extracted by mini-css-extract-plugin
export default {"container":"HeadingTop_container__unpZq","heading":"HeadingTop_heading__kuBKI","subheading":"HeadingTop_subheading__RTWj6","hr":"HeadingTop_hr__dLoZF"};